import request from "@/utils/request";
import {baseURL} from "@/utils/getawayModule";

/***
 *
 * 获取优惠包列表 get
 * @param query 分页参数
 * @return request
 * */
export function getSaleList(query) {
    return request({
        url: `${baseURL.businessApi}/sales`,
        method: 'get',
        params: query
    })
}

/**
 * 增加优惠包 post
 * @param data 增加的数据
 * @return request
 * */
export function addSale(data) {
    return request({
        url: `${baseURL.businessApi}/sales`,
        method: 'post',
        data: data
    })
}

/**
 * 删除优惠包  delete
 * @param id 优惠包id
 * @return request
 * */
export function deleteSale(id) {
    return request({
        url: `${baseURL.businessApi}/sales/${id}`,
        method: 'delete'
    })
}

/***
 * 修改优惠包 Post
 * @param id 要修改的优惠包id
 * @param data 修改的数据
 * @return request
 *
 * */
export function updateSale(id, data) {
    return request({
        url: `${baseURL.businessApi}/sales/${id}`,
        method: 'post',
        data: data
    })
}

/***
 *
 * 获取优惠包列表(后台) get
 * @param query 分页参数
 * @return request
 * */
export function getSaleBackList(query) {
    return request({
        url: `${baseURL.businessApi}/sales/back/list`,
        method: 'get',
        params: query
    })
}